import styled from 'styled-components';

export const ReMineButtonContainer = styled.div`
	background: linear-gradient(45deg, rgb(0, 198, 255), rgb(0, 114, 255));
	box-shadow: rgba(50, 50, 93, 0.1) 0px 7px 14px,
		rgba(0, 0, 0, 0.08) 0px 3px 6px;
	color: white;
	height: 45px;
	width: 45px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;
